const checkZero = data => {
  if (data.toString().length === 1) {
    data = "0" + data;
  }
  return data;
};

export const isSameDay = (day1, day2) => {
  return (
    day1.getDate() === day2.getDate() &&
    day1.getMonth() === day2.getMonth() &&
    day1.getFullYear() === day2.getFullYear()
  );
};

export const isSameMonth = (day1, day2) => {
  return (
    day1.getMonth() === day2.getMonth() &&
    day1.getFullYear() === day2.getFullYear()
  );
};

export const isDayIncluded = (day, days) => {
  return days.some(d => isSameDay(d, day));
};

export const getDatePart = day => {
  return new Date(day.getFullYear(), day.getMonth(), day.getDate());
};

export const getYearMonthPart = day => {
  return new Date(day.getFullYear(), day.getMonth());
};

export const formatDate = day => {
  return (
    checkZero(day.getDate()) +
    "/" +
    checkZero(day.getMonth() + 1) +
    "/" +
    day.getFullYear()
  );
};

export const formatMoment = moment => {
  return moment.format("YYYY-MM-DDTHH:mm:ss");
};

export const getDistinctDateFormats = (moments, format) => {
  return moments
    .map(moment => moment.format(format))
    .reduce((current, next) => {
      if (!current.includes(next)) {
        current.push(next);
      }
      return current;
    }, []);
};



// WEBPACK FOOTER //
// ./src/utils/dateHelpers.js